import React from 'react';
import { useShepherdTour } from './useShepherdTour';
import { TOUR_DATA } from './tourData';

const SessionTour = ({ autoStart = true, onComplete  }) => {
  const { startTour } = useShepherdTour('session', TOUR_DATA.session.steps, autoStart, onComplete);

  return (
    <>
    {/* <button onClick={startTour} className="btn btn-primary mt-3">
      Start Session Tour
    </button> */}
    </>
  );
};

export default SessionTour;